import { all, put, takeEvery } from 'redux-saga/effects';
import { init } from '../actions';
import { fetchPrivilegesSuccess } from '../actions/privileges';
import { fetchModulesSuccess } from '../actions/modules';
import { fetchLayoutSuccess } from '../actions/layout';
import { fetchGruserSuccess } from '../actions/gruser';
import { fetchPageSuccess } from '../actions/page';
export function* handleInit(action) {
    const { payload } = action;
    const { gruser, gruserPage: { id, name, modules, layout, privileges } } = payload;
    const page = {
        id,
        name
    };
    yield put(fetchGruserSuccess(gruser));
    yield put(fetchPageSuccess(gruser, page));
    yield put(fetchPrivilegesSuccess(gruser, privileges));
    yield put(fetchLayoutSuccess(gruser, layout));
    yield put(fetchModulesSuccess(gruser, modules));
}
export default function* rootLayoutSaga() {
    yield all([
        takeEvery(init, handleInit)
    ]);
}
